// src/components/layout/Header.js
import React from "react";
import { FiShoppingCart } from "react-icons/fi";
import { useCart } from "../../context/CartContext";

function Header() {
  const { totalItems } = useCart();

  return (
    <header className="main-header main-header-fixed">
      <nav className="navbar navbar-expand-lg navbar-light bg-white shadow-sm">
        <div className="container">
          {/* Logo / marque */}
          <a
            href="/"
            className="navbar-brand d-flex align-items-center me-2"
          >
            {/* Logo image */}
            <img
              src="/logo_prosoft.png"
              alt="ProSoft Matériels"
              className="me-2"
              style={{ height: 30, width: "auto" }} // un poil plus petit
            />

            {/* Texte de marque (masqué sur très petit écran) */}
            {/* <div className="brand-text d-none d-sm-block">
              <div className="fw-bold">ProSoft Matériels</div>
              <div className="text-muted small">
                Imprimantes · TPE · EPOS · Rouleaux
              </div>
            </div> */}
          </a>

          {/* Bouton hamburger */}
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#mainNavbar"
            aria-controls="mainNavbar"
            aria-expanded="false"
            aria-label="Basculer la navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          {/* Menu responsive */}
          <div
            className="collapse navbar-collapse justify-content-end"
            id="mainNavbar"
          >
            <ul className="navbar-nav ms-auto mb-2 mb-lg-0 main-menu">
              <li className="nav-item">
                <a className="nav-link" href="/">
                  ACCUEIL
                </a>
              </li>
              <li className="nav-item">
                <a
                  className="nav-link"
                  href="/categorie/imprimantes-ticket"
                >
                  IMPRIMANTES TICKET
                </a>
              </li>
              <li className="nav-item">
                <a
                  className="nav-link"
                  href="/categorie/imprimantes-classiques"
                >
                  IMPRIMANTES CLASSIQUES
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="/categorie/rouleaux-papier">
                  ROULEAUX PAPIER
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="/categorie/epos">
                  EPOS / CAISSES
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="/categorie/scanners">
                  SCANNERS
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="/categorie/caisses-manuelles">
                  CAISSES MANUELLES
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="/contact">
                  CONTACT
                </a>
              </li>
            </ul>

            {/* Bouton panier à droite */}
            <div className="d-flex align-items-center gap-2 ms-lg-3 mt-2 mt-lg-0">
              <a
                href="/panier"
                className="btn btn-outline-dark btn-sm btn-cart position-relative d-inline-flex align-items-center justify-content-center"
                aria-label={`Panier (${totalItems} article${
                  totalItems > 1 ? "s" : ""
                })`}
              >
                <FiShoppingCart className="cart-icon" />

                {totalItems > 0 && (
                  <span className="badge bg-primary position-absolute top-0 start-100 translate-middle rounded-pill">
                    {totalItems}
                  </span>
                )}
              </a>
            </div>
          </div>
        </div>
      </nav>
    </header>
  );
}

export default Header;
